// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"240":"ee2908f6","705":"cd105b1a"}[chunkId] + ".css";
};